import React from "react";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { exportDataGrid } from "devextreme/excel_exporter";
import { useScreenSize } from "../../../utils/media-query";
import { Button } from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { useSelector, useDispatch } from "react-redux";
import { responseTimesheet } from "../../../redux/reducers";
import { showTimesheetManager } from "../../../redux/actions";
import "./style.scss";
import TimesheetManagerTableList from "./table";

export default function TimesheetManagerList() {
  let dataGrid = React.useRef(null);
  const dispatch = useDispatch();
  const { timesheet } = useSelector(responseTimesheet);
  React.useEffect(() => {
    dispatch(showTimesheetManager());
  }, [dispatch]);

  const { isXSmall, isSmall } = useScreenSize();

  const handleExportExcel = () => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    const data = dataGrid.current.instance;
    exportDataGrid({
      component: data,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "DataGrid.xlsx"
        );
      });
    });
  };
  const handleRefreshDataGrid = () => {
    dataGrid.current.instance.refresh();
  };
  const onCellPrepared = (e) => {
    if (e.rowType === "data" && e.column.dataField === "status") {
      if (e.data.status === "Pending") {
        e.cellElement.className = "color-accent";
      } else if (e.data.status === "Approved") {
        e.cellElement.className = "color-success";
      } else {
        e.cellElement.className = "color-danger";
      }
    }
  };

  return (
    <div>
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>Timesheet Manager</div>
        </div>
        <div className={"breadcrumb-right"}>
          {/* <Link to="/timesheet-manager/list" className={"breadcrumb-item"}>
            Timesheet Manager
          </Link> */}
          <span className={"breadcrumb-item active"}>Timesheet Manager</span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <Toolbar className="datagrid-toolbar-actions">
            <Item
              location="after"
              locateInMenu={isXSmall || isSmall ? "always" : "auto"}
              cssClass={"datagrid-toolbar-actions-dropdown"}
            >
              <Button
                icon={`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6667 8.66667V12C12.6667 12.3667 12.3667 12.6667 12 12.6667H4C3.63333 12.6667 3.33333 12.3667 3.33333 12V8.66667C3.33333 8.3 3.03333 8 2.66667 8C2.3 8 2 8.3 2 8.66667V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8.66667C14 8.3 13.7 8 13.3333 8C12.9667 8 12.6667 8.3 12.6667 8.66667ZM8.66667 8.44667L9.92 7.19333C10.18 6.93333 10.6 6.93333 10.86 7.19333C11.12 7.45333 11.12 7.87333 10.86 8.13333L8.46667 10.5267C8.20667 10.7867 7.78667 10.7867 7.52667 10.5267L5.13333 8.13333C4.87333 7.87333 4.87333 7.45333 5.13333 7.19333C5.39333 6.93333 5.81333 6.93333 6.07333 7.19333L7.33333 8.44667V2.66667C7.33333 2.3 7.63333 2 8 2C8.36667 2 8.66667 2.3 8.66667 2.66667V8.44667Z" fill="#384455"/></svg>`}
                text="Export"
                onClick={handleExportExcel}
                className="mr-1"
              />
              <Button
                icon="revert"
                text="Refresh"
                className="mr-1"
                onClick={handleRefreshDataGrid}
              />
            </Item>
          </Toolbar>
          <TimesheetManagerTableList
            onCellPrepared={onCellPrepared}
            dataTable={timesheet}
            dataGrid={dataGrid}
            isSmall={isSmall}
            isXSmall={isXSmall}
          />
        </div>
      </div>
    </div>
  );
}
